import React, { useEffect } from 'react';
import { getSession, setSession } from './index';
import logger from '../ErrorBoundary/logger_new';

export const getContentSquareUrl = () => {
  let replayLink;
  const isRecording = window._uxa.push(['isRecording']);
  if (isRecording) {
    const uxaGet = window._uxa.push(['getSessionData']);
    if (uxaGet && uxaGet.projectId) {
      const pid = uxaGet.projectId;
      const uu = uxaGet.userId;
      const sn = uxaGet.sessionNumber;
      const pvid = uxaGet.pageNumber; // index+1

      if (pid && uu && sn && pvid) {
        replayLink = `https://app.contentsquare.com/quick-playback/index.html?pid=${pid}&uu=${uu}&sn=${sn}&pvid=${pvid}&recordingType=cs&vd=md`;
        if (window.CS_CONF) {
          window.CS_CONF.replaylink = replayLink;
        }
      }
    }
  }
  return replayLink;
};

export const logContentSquareReplayUrl = () => {
  if (getSession('digitalCSLog') !== 'Y') {
    setSession('digitalCSLog', 'Y');
    const contentSquareUrl = getContentSquareUrl();
    if (contentSquareUrl) {
      logger({
        message: contentSquareUrl || '',
        eventType: 'CSReplay',
        json: true,
      });
    }
  }
};

export const setContentSquareInitCallback = () => {
  function csCallback() {
    try {
      // Functions to be called after Content Square Initialization
      logContentSquareReplayUrl();
    } catch (error) {
      console.error(error);
    }
  }
  window._uxa = window._uxa || [];
  window._uxa.push(['afterPageView', csCallback]);
};

// Used to ensure the callback runs once only on Client
export const ContentSquareInit = () => {
  useEffect(() => {
    setContentSquareInitCallback();
    console.log('ssssss=>');
  }, []);
  return <></>;
};
